import { render, staticRenderFns } from "./ResultsPersonality.vue?vue&type=template&id=496fe57a&"
import script from "./ResultsPersonality.vue?vue&type=script&lang=js&"
export * from "./ResultsPersonality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports